/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2020-08-29
 */

export const MAP_SIZE_MIN: number = 1;

export const MAP_SIZE_MAX: number = 12;

export const MAP_SIZE_DEFAULT: number = 4;

export const MILESTONES_MIN: number = 1;

export const MILESTONES_MAX: number = 20;

export const MILESTONES_DEFAULT: number = 3;

export const PRESTIGE_MIN: number = 1;

export const PRESTIGE_MAX: number = 1500;

export const GAME_SPEED_MIN: number = 1;

export const GAME_SPEED_MAX: number = 20;

export const KNOWLEDGE_MIN: number = 1;

export const KNOWLEDGE_MAX: number = 20;

export const CHALLENGES_MIN: number = 1;

export const CHALLENGES_MAX: number = 20;

export const LOCATION_COUNT_MIN: number = 1;

export const LOCATION_COUNT_MAX: number = 12;

export const LOCATION_MAP_MIN: number = 0;

export const LOCATION_MAP_MAX: number = 1;

export const LOCATION_LAKES_MIN: number = 1;

export const LOCATION_LAKES_MAX: number = 20;

export const LOCATION_POSITION_MIN: number = 0;

export const LOCATION_POSITION_MAX: number = MAP_SIZE_MAX * 512;

export const LOCATION_SEED_MIN: number = 0;

export const LOCATION_SEED_MAX: number = 999999999;

